import { createContext } from "react";

const TransContext = createContext({});

export default TransContext;
